import React, { FC } from 'react';

import moment from 'moment-timezone';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import { gridTheme } from '@utils/grid';
import { useIsWindowWiderThan } from '../../hooks';

import { DesktopInput } from './DesktopInput';

import { StyledDateRangePickerWrapper } from '../DateRangeInput';

import { MobileInput } from './MobileInput';
import { DateInputProps } from './types';

export const DateInput: FC<DateInputProps> = ({ startDate = moment(), onDateChange }) => {
  const isWiderViewport = useIsWindowWiderThan(gridTheme.breakpoints.md);
  const Input = isWiderViewport ? DesktopInput : MobileInput;
  return (
    <StyledDateRangePickerWrapper>
      <Input startDate={startDate} onDateChange={onDateChange} />
    </StyledDateRangePickerWrapper>
  );
};
